declare var WP_NONCE_REST : string;

document.addEventListener('DOMContentLoaded', () => {

    const endpointURL = '/wp-json/workmode/v1/demo-sessions/';
    const participantsEndpointURL = '/wp-json/workmode/v1/demo-participants/';

    /* Create new room button */
    document
        .getElementById('create-new-room-button')
        .addEventListener('click', (event) => {
            fetch(
                endpointURL, {
                    method: 'POST',
                    // body: "nonce=" + WP_NONCE_REST,
                    headers: {
                        'X-WP-Nonce': WP_NONCE_REST
                    }
                })
                .then( (result : Response) => {
                    if(result.status !== 200) {
                        return Promise.reject(result);
                    }
                    return result.json();
                })
                .then((data) => {
                    window.location.reload();
                })
                .catch((reason) => {
                    console.log("Couldn't create room", reason);
                })
        });

    /* Delete */
    document
        .querySelectorAll(".delete-room-button")
        .forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                if(event.target instanceof HTMLElement) {
                    const dailyRoomName = event.target.getAttribute("data-daily-room-name");
                    fetch(
                        endpointURL + dailyRoomName + "/", {
                            method: 'DELETE',
                            headers: {
                                'X-WP-Nonce': WP_NONCE_REST
                            }
                        }
                    )
                    .then( (result : Response) => {
                        if(result.status !== 200) {
                            return Promise.reject(result);
                        }
                        return result.json();
                    })
                    .then((data) => {
                        console.log("Removing room: " + dailyRoomName);
                        button.closest("li").remove();
                    })
                    .catch((reason) => {
                        console.log("Couldn't create room", reason);
                    })
                }
            });
        });

    /* Refresh participants list */
    document
        .querySelectorAll('.demo-rooms-list-room-row')
        .forEach( (roomRow) => {
            const roomName = roomRow.getAttribute("data-room-name");
            /* Refresh participants list every REFRESH_INTERVAL seconds */
            const REFRESH_INTERVAL = 5 * 1000;

            const refreshHandler = () => {
                console.log(`Refreshing participants list for room: ${roomName}`);
                fetch(
                    participantsEndpointURL + roomName + "/", {
                        method: 'GET',
                        headers: {
                            'X-WP-Nonce': WP_NONCE_REST
                        }
                    })
                    .then( (result : Response) => {
                        if(result.status !== 200) {
                            return Promise.reject(result);
                        }
                        return result.json();
                    })
                    .then((data) => {
                        updateParticipantsList(roomName, data.participants);
                    })
                    .catch((reason) => {
                        console.log(`Couldn't fetch participants list for room ${roomName}`, reason);
                    })
            };

            const updateParticipantsList = function(roomName : String, participants ) : void {
                document
                    .querySelectorAll(`.demo-rooms-list-room-row[data-room-name='${roomName}'] .demo-rooms-list-participants`)
                    .forEach((participantsContainer) => {
                        const allUserNames = participants
                            .map( participant => participant.user_name )
                            .join(", ");
                        participantsContainer.innerHTML = allUserNames;
                    });
            };

            refreshHandler();
            setInterval( refreshHandler, REFRESH_INTERVAL)
        })
});